
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/mining-pool",
      function () {
        return require("private-next-pages/dashboard/mining-pool/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/mining-pool"])
      });
    }
  